<template>
  <div>
    <div class="text-xs-center">
      <h2 class="px-5 pt-4 pb-2">Congratulations 🎉, Your campaign and landing page are ready to accept leads!</h2>
      <div class="subheading font-weight-light pt-3">Things you can do now:</div>
    </div>
    <v-list two-line class="ma-3">
      <v-divider></v-divider>
      <v-list-tile ripple :href="value" target="_blank">
        <v-list-tile-avatar>
          <v-avatar
            color="blue-grey lighten-2"
            class="subheading white--text"
            size="24"
            v-text="1"
          ></v-avatar>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold blue--text">
            Generate Leads from Landing Page
          </v-list-tile-title>
          <v-list-tile-sub-title class="">
            Drive traffic to your page to capture leads.
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile ripple :to="{ name: 'CampaignDetails', params: { id: campaignId }, query: { tab: 'widget_code' }}" target="_blank">
        <v-list-tile-avatar>
          <v-avatar
            color="blue-grey lighten-2"
            class="subheading white--text"
            size="24"
            v-text="2"
          ></v-avatar>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold blue--text">
            Generate Leads from your Web-site
          </v-list-tile-title>
          <v-list-tile-sub-title>
            Add widget code to your site to start capturing leads.
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile ripple :to="{ name: 'CampaignDetails', params: { id: campaignId }, query: { tab: 'landing_page' }}" target="_blank">
        <v-list-tile-avatar>
          <v-avatar
            color="blue-grey lighten-2"
            class="subheading white--text"
            size="24"
            v-text="3"
          ></v-avatar>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold blue--text">
            Edit Campaign and Landing Page
          </v-list-tile-title>
          <v-list-tile-sub-title>
            Click "GO TO MY ACCOUNT" button to edit your campaign and landing page.
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
    <div class="pa-4 mb-3 text-xs-center">
      <a class="v-btn v-btn--large theme--dark success"
        :href="value"
        target="_blank">
        View Landing Page
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    campaignId: [Number, String],
  },
};
</script>
<style scoped>
  hr {
    margin-top: 0;
    margin-bottom: 0;
  }
  .v-list__tile__sub-title, .v-list__tile__title {
    white-space: normal;
    overflow: auto;
    text-overflow: unset;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Signup/Congratulations.vue